/// <reference path="../../vite-env.d.ts" />
import type { PinchcrewApi } from './client'
import { HttpApi } from './http'
import { MockApi } from './mock'

/**
 * Adapter selection — the ONE place mock swaps for the real backend.
 * Set VITE_API_BASE_URL to point at Django and the mock drops out entirely.
 */
const baseUrl = import.meta.env?.VITE_API_BASE_URL as string | undefined

export const api: PinchcrewApi = baseUrl ? new HttpApi(baseUrl) : new MockApi()
export const usingMockApi = !baseUrl

export * from './types'
export { ApiRequestError } from './client'
export { MockApi } from './mock'
export { HttpApi } from './http'
export type { PinchcrewApi, ShiftFilters } from './client'
export * from './employer'
export * from './ops'
